import { ensure } from "./ensure"

export function encode(input: string) {
  const base36 = "abcdefghijklmnopqrstuvwxyz0123456789"
  let encoded = ""

  for (let i = 0; i < input.length; i++) {
    const charCode = input.charCodeAt(i)
    encoded += base36[(charCode >> 3) & 31]
    encoded += base36[charCode & 31]
  }

  return encoded
}

export function decode(encoded: string) {
  const base36 = "abcdefghijklmnopqrstuvwxyz0123456789"
  let decoded = ""

  for (let i = 0; i < encoded.length; i += 2) {
    const firstChar = base36.indexOf(ensure(encoded[i]))
    const secondChar = base36.indexOf(ensure(encoded[i + 1]))

    const charCode = (firstChar << 3) | secondChar
    decoded += String.fromCharCode(charCode)
  }

  return decoded
}
